import React from "react";
import ScrollBar from "./ScrollBar/ScrollBar";

const OurProcess = () => {
  return (
    <section
      style={{
        textAlign: "center",
        background: "linear-gradient(180deg, #ffffff, #f9f9ff)",
        padding: "60px 20px",
      }}
    >
      <h2 style={{ fontSize: "36px", fontWeight: "700", marginBottom: "10px" }}>
        Our Process, Your <span style={{ color: "rgb(104, 91, 255)" }}>Success</span>
      </h2>
      <p style={{ fontSize: "18px", color: "rgb(117, 123, 134)", marginBottom: "40px" }}>
        Our process is designed to keep supported application work moving while you review the activity.
      </p>

      <div style={{ position: "relative" }}>
        <ScrollBar />
      </div>
    </section>
  );
};

export default OurProcess;
